export default "__VITE_ASSET__BPIFH7sW__"